import { Outlet } from 'react-router-dom';
import { FamilyProvider } from '../../contexts/FamilyContext';
import { FeedingGroupsProvider } from '../../contexts/FeedingGroupsContext';
import { HydrationGroupsProvider } from '../../contexts/HydrationGroupsContext';
import { PetsProvider } from '../../contexts/PetsContext';
import { NotificationsProvider } from '../../contexts/NotificationsContext';
import { AppointmentsProvider } from '../../contexts/AppointmentsContext';
import { HealthProvider } from '../../contexts/HealthContext';
import TopBar from './TopBar';
import BottomNav from './BottomNav';

const AppShell = () => {
  return (
    <FamilyProvider>
      <FeedingGroupsProvider>
        <HydrationGroupsProvider>
          <PetsProvider>
            <NotificationsProvider>
              <AppointmentsProvider>
                <HealthProvider>
                  <div className="flex min-h-[100dvh] flex-col bg-slate-50">
                    <TopBar />
                    <main
                      className="flex-1 overflow-y-auto px-4 pb-24 pt-4"
                      style={{ paddingBottom: 'calc(6rem + env(safe-area-inset-bottom))' }}
                    >
                      <Outlet />
                    </main>
                    <BottomNav />
                  </div>
                </HealthProvider>
              </AppointmentsProvider>
            </NotificationsProvider>
          </PetsProvider>
        </HydrationGroupsProvider>
      </FeedingGroupsProvider>
    </FamilyProvider>
  );
};

export default AppShell;